import { Link } from '@mui/material';
import type { ToastAction } from '../types';

/**
 * A notification's secondary action rendered as an inline text link, appended to the end of the
 * message body so it flows with the text. Deliberately inline (no block/flex wrapper) so it
 * claims no extra row, column, width, or height in either the toast or the history list.
 */
export function SecondaryActionLink({ action, onClick }: { action: ToastAction; onClick: () => void }) {
  return (
    <>
      {' '}
      <Link
        component="button"
        type="button"
        variant="inherit"
        underline="hover"
        onClick={onClick}
        sx={{ verticalAlign: 'baseline' }}
      >
        {action.label}
      </Link>
    </>
  );
}
